import { apiCall } from '../../context/api';

export const forgotPassword = async (email, base_url) => {
  return apiCall(base_url, null, 'POST', '/core/users/forgot-password', { email });
};
